import { render, staticRenderFns } from "./54.vue?vue&type=template&id=4a654d38&scoped=true&"
import script from "./54.vue?vue&type=script&lang=js&"
export * from "./54.vue?vue&type=script&lang=js&"
import style0 from "./54.vue?vue&type=style&index=0&id=4a654d38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a654d38",
  null
  
)

export default component.exports